import {
  UpdateReportTextTemplateDto,
  UpdateReportTextTemplateResponse,
} from '@ansvar-sakerhet/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import {
  reportTextTemplateKeys,
} from './reportTextTemplates.key';
import { ReportTextTemplateKey } from './useGetReportTextTemplate';
import { toast } from '../../../components/Toast';

type Options = {
  onSuccess?: (data: UpdateReportTextTemplateResponse) => void;
  onError?: (error: unknown) => void;
};

export function useUpdateReportTextTemplate(
  key: ReportTextTemplateKey,
  options?: Options
) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const updateTemplate = async (data: UpdateReportTextTemplateDto) => {
    const api = await getApi();
    const res = await api.reportTextTemplatesUpdate(key, data);
    return res.data;
  };

  const onSuccess = (data: UpdateReportTextTemplateResponse) => {
    toast.success('Mallen har uppdaterats');
    queryClient.invalidateQueries({
      queryKey: reportTextTemplateKeys.findOne(key),
    });
    queryClient.invalidateQueries({
      queryKey: reportTextTemplateKeys.findMany(),
    });
    options?.onSuccess?.(data);
  };

  const onError = (error: unknown) => {
    toast.error('Något gick fel när mallen skulle uppdateras');
    options?.onError?.(error);
  };

  return useMutation(updateTemplate, {
    onSuccess,
    onError,
  });
}
